export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14939.c632786e.jpg";